import { default as MuiBadge } from '@mui/material/Badge';

/**
 * A badge is a label that communicates status to customers.
 *
 * Demos:
 *
 * - [Badge](https://unify.workiva.org/components/badge?tab=code)
 *
 * API:
 *
 * - [Badge API](https://unify.workiva.org/components/badge?tab=props)
 */
export const Badge = MuiBadge;
export { type BadgeProps, type BadgeOrigin } from '@mui/material/Badge';
export { default as badgeClasses } from './badgeClasses';
